/**
 * @file 打字机 简易动画 hook
 * @author malcolmmzma
 */

import { useCallback, useEffect, useState } from 'react';

const useTypeAnimation = (text: string, { speed = 50, delay = 0 }) => {
  const [initialized, setInitialized] = useState(false);
  const [displayedText, setDisplayedText] = useState('');
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);

  const doAnimation = useCallback(() => {
    if (!text) {
      return;
    }
    let index = 0;
    const interval = setInterval(() => {
      if (index < text.length) {
        setDisplayedText((prev) => prev + text[index]);
        index += 1;
      } else {
        clearInterval(interval);
      }
    }, speed);
    setIntervalId(interval);
  }, [speed, text]);

  const replay = useCallback(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setDisplayedText('');
    doAnimation();
  }, [doAnimation, intervalId]);

  useEffect(() => {
    if (initialized) {
      return;
    }
    setInitialized(true);
    // 如果有延迟，先等待一段时间再开始动画
    if (delay > 0) {
      setTimeout(() => {
        doAnimation();
      }, delay);
      return;
    }
    doAnimation();
  }, [delay, doAnimation, initialized]);

  useEffect(
    () => () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    },
    [intervalId],
  );

  return {
    displayedText,
    replay,
    isComplete: displayedText.length === text.length,
  };
};

export default useTypeAnimation;
